import { SendEmail } from '../../components/auth/resetPassword/SendEmail'
export const SendEmailResetPassword = () => {
    return (
        <SendEmail />
    )
}